import React from "react";

import { UseFormReturn } from "react-hook-form";

import {
	ManageUserState
} from "./models";

import { Content, } from "models/content";

import {
	Box, Button, Stack, Typography
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import UploadIcon from '@mui/icons-material/Upload';

import { t, Trans } from "@lingui/macro";
import { withSnackbar, WithSnackbarProps } from "notistack";

import ZPlayLoader from "commons/zplay-loader";

import NavigationBack from "commons/navigation/navigation-back/navigation-back";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { DefaultTypedResponse } from "models/response";
import {User, UserType} from "models";
import UserService from "services/user-service";
import UserTable from "components/backoffice/user/user-table/user-table";
import  UploadModal  from "commons/modal/upload-modal";

class ManageUser extends React.Component<UseFormReturn & WithSnackbarProps & RouteComponentProps, ManageUserState>
{
	constructor(props: any) {
		super(props);

		this.state = {
			pagination: { pageSize: 20, pageIndex: 0 },
			userCount: 0,
			userList: [],
			data: null,
			loaded: false,
			isUploadModalOpen: false
		};
	}

	public componentDidMount() {

		////****
		//VERY VERY IMPORTANTE! Mongoose Paginate prende di default come prima pagina la pagina 1, mentre la tabella la pagina 0. Serve questo piccolo workaround
		////****
		this.getPaginatedUserWithStateParameters();
	}

	private getUserCallback = (data: DefaultTypedResponse<User>): void => {

		this.setState(() => ({
			userCount: data.size,
			userList: data.list,
			loaded: true,
		}));

	};

	private getUserErrorCallback = (err: any): void => {
		this.setState(() => ({
			loaded: false,
		}));
	};

	private getPaginatedUserWithStateParameters = () => {

		this.setState(() => ({
			loaded: false,
		}));

		UserService.getUserListPaginated([["pageId", this.state.pagination.pageIndex + 1], ["pageSize", this.state.pagination.pageSize]], this.getUserCallback, this.getUserErrorCallback);
	}

	private paginationUpdated = (pagination: any) => {

		////****
		//VERY IMPORTANTE! Mongoose Paginate prende di default come prima pagina la pagina 1, mentre la tabella la pagina 0. Serve questo piccolo workaround
		////****

		this.setState(() => ({
			loaded: false,
			pagination: pagination
		}), () => UserService.getUserListPaginated([["pageId", this.state.pagination.pageIndex + 1], ["pageSize", this.state.pagination.pageSize]], this.getUserCallback, this.getUserErrorCallback));

	}

	private deleteUser = (id: string): void => {
		this.setState(() => ({
			loaded: false,
		}));

		if ((this.state.userList.length - 1) % this.state.pagination.pageSize === 0 && this.state.pagination.pageIndex !== 0) {
			this.setState((prevState) => ({
				pagination: {
					...prevState.pagination,
					pageIndex: this.state.pagination.pageIndex - 1
				}
			}));
		};

		UserService.deleteUser(id, this.deleteUserCallback, this.deleteUserErrorCallback);
	}

	private deleteUserCallback = (data: DefaultTypedResponse<Content>): void => {

		this.setState(() => ({
			loaded: true,
		}));

		this.getPaginatedUserWithStateParameters();
	};

	private deleteUserErrorCallback = (err: any): void => {
		
		this.setState(() => ({
			loaded: true,
		}));

		this.props.enqueueSnackbar(t({
			id: "mu-delete-user-error",
			message: "Si è verificato un errore. Non è stato possibile eliminare l'utente"
		}), {
			variant: "error",
		});
	};
	
	private goToCreate = (): void => {
		let { history } = this.props
		history.push("/backoffice/create-user");
	}

	private openUploadModal = () => {
		this.setState(() => ({
			isUploadModalOpen: true
		}))
	}

	private closeUploadModal = () => {
		this.setState(() => ({
			isUploadModalOpen: false
		}))
	}

	private confirmCsvUpload = async (file: File, userType : UserType) => {


		this.fileToBase64(file).then((base64String) => {
			if (base64String) {
                this.setState(() => ({
                    loaded: false,
                    isUploadModalOpen: false
                }));
                UserService.createUsersFromCSV(base64String, userType, this.createUsersFromCSVCallback, this.createUsersFromCSVCallbackError)
			} else {
                this.props.enqueueSnackbar(t({
                    id: "mu-convert-csv-file-error",
                    message: "Si è verificato un errore. Non è stato possibile processare il file"
                }), {
                    variant: "error",
                });
			}
		}).catch((error) => {
                this.props.enqueueSnackbar(t({
                    id: "mu-convert-csv-file-error",
                    message: "Si è verificato un errore. Non è stato possibile processare il file"
                }), {
                    variant: "error",
                });
			});

	}

    private createUsersFromCSVCallback = (email: string[]) => {
        this.setState(() => ({
            loaded: true,
        }));
        if(email.length===0){
            this.props.enqueueSnackbar(t({
                id: "mu-crate-user-csv-success",
                message: "Gli utenti sono stati pre-pregistrati"
            }), {
                variant: "success",
            });
        }else{
            this.props.enqueueSnackbar(t({
                id: "mu-crate-user-csv-warning",
                message: "Si è verificato un errore pre-registrando alcuni utenti"
            }), {
                variant: "warning",
            });
        }
        this.getPaginatedUserWithStateParameters();
    }

    private createUsersFromCSVCallbackError = (data: any) => {

        this.setState(() => ({
            loaded: true,
        }));
        this.props.enqueueSnackbar(t({
            id: "mu-crate-user-csv-error",
            message: "Si è verificato un errore, riprova più tardi"
        }), {
            variant: "error",
        });

    }


    private fileToBase64 = (file: File): Promise<string | null>  => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();

		reader.onload = (event) => {
			if (event.target) {
				const result = event.target.result as string;
				const base64String = result.split(',')[1];
				resolve(base64String);
			} else {
				reject(new Error('Errore nella lettura del file.'));
			}
		};

		reader.onerror = () => {
			reject(new Error('Errore nella lettura del file.'));
		};

		reader.readAsDataURL(file);
	});
}

	render() {
		return (
			<Box sx={{ textAlign: "center", p: 5 }}>
				<NavigationBack/>
				<Typography variant="h2" color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}>
					<Trans id="mu-text-title">Utenti</Trans>
				</Typography>
				<Stack direction="row" mt={3} gap={2}>
					<Typography sx={{ flexGrow: 1 }} />
					<Button
							endIcon={<UploadIcon />}
							onClick={this.openUploadModal}
							variant={"contained"}
							size="small"
					>
							<Trans id="mu-button-add-csv">Carica CSV</Trans>
					</Button>
					<Button
							endIcon={<AddIcon />}
							onClick={this.goToCreate}
							variant={"contained"}
							size="small"
					>
							<Trans id="mu-button-add">Aggiungi</Trans>
					</Button>
				</Stack>
				{this.state.loaded && <Box mt={2}>
					<UserTable
						pagination={this.state.pagination}
						users={this.state.userList}
						totalUserCount={this.state.userCount}
						deleteUser={this.deleteUser}
						updatePaginationCallBackFn={this.paginationUpdated}/>
				</Box>}
				{!this.state.loaded && <ZPlayLoader />}
				{this.state.isUploadModalOpen && 
					<UploadModal 
						closeModal={this.closeUploadModal} 
						confirmCallback={this.confirmCsvUpload}
						header={["Id", "Date", "Status", "Email"]}
						errorMessage={"Le colonne del csv devono essere: Id, Date, Status, Email"}
						errorMessageId={"mu-csv-column-error"}
						isUserCSV={true}
				/>}
			</Box>);
	}
}

export default withRouter(withSnackbar(ManageUser));